module.exports = __webpack_public_path__ + "img/chevron-left.a95bd0c9.svg";